<script setup>
import { ref } from "vue";
import heroImage from "@/assets/img/background/image3.png";
import { loadSlim } from "tsparticles-slim";

import StepperPeleador from "@/components/Evento-Julio/Peleadores/StepperPeleador.vue";
import Step1DatosPeleador from "@/components/Evento-Julio/Peleadores/Step1DatosPeleador.vue";
import Step2DatosCombate from "@/components/Evento-Julio/Peleadores/Step2DatosCombate.vue";

const activeStep = ref(0);
const stepsEnabled = ref([true, false]);

const particleConfig = {
  background: { color: "transparent" },
  particles: {
    number: { value: 40 },
    color: { value: "#00aaff" },
    shape: { type: "circle" },
    opacity: { value: 0.25 },
    size: { value: 3 },
    move: { enable: true, speed: 1.2, direction: "none", outModes: "out" },
  },
};
const particlesInit = async (engine) => await loadSlim(engine);

function nextStep() {
  if (activeStep.value < stepsEnabled.value.length - 1) {
    stepsEnabled.value[activeStep.value + 1] = true;
    activeStep.value += 1;
  }
}

function prevStep() {
  if (activeStep.value > 0) activeStep.value -= 1;
}
</script>

<template>
  <section class="registro-wrapper">
    <div class="hero-bg-image" :style="{ backgroundImage: `url(${heroImage})` }"></div>
    <div class="hero-gradient"></div>
    <Particles id="tsparticles" :init="particlesInit" :options="particleConfig" />
    <div class="smoke-layer"></div>

    <div class="registro-content">
      <div class="form-box">
        <!-- ══ STEPPER + PASOS ══ -->
        <StepperPeleador v-model="activeStep" :steps-enabled="stepsEnabled" />

        <Step1DatosPeleador v-if="activeStep === 0" @next-step="nextStep" />

        <Step2DatosCombate v-if="activeStep === 1" @prev-step="prevStep" />
      </div>
    </div>
  </section>
</template>

<style scoped>
.registro-wrapper {
  position: relative;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
  overflow: hidden;
}
.hero-bg-image {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: brightness(0.75) contrast(1.2);
  z-index: 1;
}
.hero-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.9) 0%,
    rgba(0, 20, 45, 0.7) 50%,
    rgba(0, 0, 0, 0.95) 100%
  );
  z-index: 2;
}
#tsparticles {
  position: absolute;
  inset: 0;
  z-index: 3;
}
.smoke-layer {
  position: absolute;
  inset: 0;
  background: url("https://c4.wallpaperflare.com/wallpaper/448/699/737/abstract-digital-art-3d-abstract-lines-wallpaper-preview.jpg");
  opacity: 0.22;
  mix-blend-mode: lighten;
  animation: smokeMove 20s infinite linear;
  z-index: 4;
}
@keyframes smokeMove {
  0% {
    transform: translateY(0) scale(1.2);
  }
  100% {
    transform: translateY(-20%) scale(1.25);
  }
}
.registro-content {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 2rem;
}
.form-box {
  background: #fff;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 860px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

@media (max-width: 600px) {
  .form-box {
    padding: 1.25rem;
    border-radius: 12px;
  }
  .registro-wrapper {
    padding: 4rem 0.75rem 2rem;
  }
}
</style>
